module.exports = __webpack_public_path__ + "static/media/SF-1-if-wrong.a2c9fa68.mp3";